import React from 'react'

import AktivitetsTyp from "../../../SkapaMote/Inputs/AktivitetsTyp";
import EndDateTime from "./Inputs/EndDateTime";
import TitleInput from "./Inputs/Title";
import Kommentar from "../../../SkapaMote/Inputs/Kommentar";
import TagsInput from "../../../SkapaMote/Inputs/TagsInput";
import AktivitetsisKlar from "../../../SkapaMote/Inputs/AktivitetsisKlar";
import SelectMedArbetare from "../../../SkapaMote/Inputs/SelectMedArbetare";
import SelectMultiMedArbetare from "../../../SkapaMote/Inputs/SelectMultiMedArbetare";
import AnteckningDel from 'components/NotyfileAnteckningInput'
import IntlMessages from 'util/IntlMessages';
import {Grid, Box, IconButton} from '@material-ui/core'
import RemoveIcon from '@material-ui/icons/HighlightOff'

import { fade, makeStyles } from '@material-ui/core/styles';
import {isEmpty} from 'lodash'

import {useSelector, useDispatch} from 'react-redux'
import {getAktivitetTypes} from 'actions'
const useStyles = makeStyles(theme => ({
  badgeRoot: {
    fontSize: 14,
    letterSpacing: 0.5,
    borderRadius: 4,
    padding: '2px 12px',
    marginRight: 5,
    marginBottom: 5,
    fontWeight: 500,
    display: 'inline-block'
  },
}));

export default function Step2({state, setAktivitet, setState}) {
  const classes = useStyles();
  const dispatch = useDispatch()
  const Afid = useSelector(state=>state.auth.authUser.user_Afid)
  const onchangeHanelAktivitet = (Key, Value) => {
    console.log(Key, Value)
    setState(state => ({
      ...state,
      newAktivitet: {
        ...state.newAktivitet,
        Aktivitet: {
          ...state.newAktivitet.Aktivitet,
          [Key]: Value
        }
      }
    }))
  }

  const handleRemoveTag=(Tag)=>{
    setState(state => ({...state, newAktivitet: { ...state.newAktivitet, Tags: state.newAktivitet.Tags.filter(t => t.keyword !== Tag.keyword)}}))
  }
  const handleAddTag=(Tag)=>{
    //add
    setState(state => {

      let Array = [...state.newAktivitet.Tags]
      Array.push(Tag)

      return {
        ...state, 
        newAktivitet: { 
          ...state.newAktivitet, 
          Tags: Array
    }}})
  }
  React.useEffect(()=>{
    dispatch(getAktivitetTypes(Afid))
  },[])
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TitleInput
          title={state.newAktivitet.Aktivitet.title}
          onchangeHanelAktivitet={onchangeHanelAktivitet}
          />
      </Grid>
      <Grid item xs={6}>
        <AktivitetsTyp
          Type={state.newAktivitet.Aktivitet.type}
          onchangeHanelAktivitet={onchangeHanelAktivitet}
          />
      </Grid>
      <Grid item xs={6}>
        <AktivitetsisKlar
          isKlar={state.newAktivitet.Aktivitet.isKlar}
          onchangeHanelAktivitet={onchangeHanelAktivitet}
          />
      </Grid>
      <Grid item xs={12}>
        <div style={{border: '1px solid #ccc', borderRadius: 4}}>
          <AnteckningDel
            title={<IntlMessages id="Table.Description"/>}
            isLoading={false}
            message={''}
            Body={state.newAktivitet.Aktivitet.Body}
            onChange={(v) => onchangeHanelAktivitet('Body', v)}
            hiddenAttachBtn={1}
            hiddenSaveBtn={1}
            hideFullscreen
          />
        </div>
      </Grid>
      
      <Grid item xs={6}>
        <TagsInput
          onchangeHanelTags={handleAddTag}
          />
      </Grid>
      <Grid item xs={6}>
        <EndDateTime
          Name="Datum"
          isFrom="1"
          endDate={state.newAktivitet.Aktivitet.endDatetime}
          UpdateDate={0}
          onchangeHanelEvent={onchangeHanelAktivitet}
          />
      </Grid>
      {!isEmpty(state.newAktivitet.Tags) && <Grid item xs={12}><div>{state.newAktivitet.Tags.map(t => (
        <Box
          component="span"
          className={classes.badgeRoot}
          style={{
            backgroundColor: fade(t.color, 0.2),
            color: t.color,
          }}>
          {t.keyword}
          <IconButton size="small" style={{height: 16, width: 16}} onClick={() => handleRemoveTag(t)}>
            <RemoveIcon style={{fontSize:18, marginLeft: 5, color: t.color}}/>
          </IconButton>
        </Box>
        ))}</div></Grid>
      }
      {
        state.newAktivitet.personal === 1 &&
        <>
          <Grid item xs={12}>
            <SelectMedArbetare
              Ansvarig={state.newAktivitet.ansvarig}
              disabled={true}
              onchangeHanelansvarig={(ansvarig) => setAktivitet('ansvarig', parseInt(ansvarig))}
            />
          </Grid>
          <Grid item xs={12}>
            <SelectMultiMedArbetare
              MedArbetare={state.newAktivitet.MedArbetare}
              onchangeHanelMedArbetare={(MedArbetare) => setAktivitet('MedArbetare', MedArbetare)}
              isAktivitet={1}
            />
          </Grid>
        </>
      }
    </Grid>
  )
}
